import api from "./api";

const BASE = "/administration";

export const getMyTickets = (params = {}) =>
  api.get(`${BASE}/support-tickets/`, { params });

export const getAllTickets = (params = {}) =>
  api.get(`${BASE}/support-tickets/`, { params });

export const createTicket = (data) =>
  api.post(`${BASE}/support-tickets/`, data);

export const respondToTicket = (id, data) =>
  api.post(`${BASE}/support-tickets/${id}/respond/`, data);

export const updateTicket = (id, data) =>
  api.patch(`${BASE}/support-tickets/${id}/`, data);
